import { I18nProvider } from 'i18n/I18nProvider';
import { FoundationProvider } from '@hiiretail/react-foundation-ui';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './App';
import store from './app/store/store';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <Provider store={store}>
      <I18nProvider>
        <FoundationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App />
          </LocalizationProvider>
        </FoundationProvider>
      </I18nProvider>
    </Provider>
  </StrictMode>,
);
